"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantConfig = void 0;
class TenantConfig {
    constructor(config = {}) {
        this.config = config;
    }
    get cacheExpiration() {
        return this.config.cache_expiration || 5000;
    }
    get debug() {
        return this.config.debug;
    }
    get remoteBaseUrl() {
        if (this.config.remote_base_url)
            return this.config.remote_base_url;
        return (process.env.CMS_REMOTE_CONTENT_BASE_URL ||
            'https://cms-content-staging.sleek.com');
    }
    get environment() {
        if (this.config.environment)
            return this.config.environment;
        // Connect to sit environment by default
        if (process.env.NODE_ENV === 'development') {
            return 'sit';
        }
        return process.env.NODE_ENV || 'sit';
    }
    get countryCode() {
        return this.config.country_code || process.env.COUNTRY_CODE || 'SGP';
    }
}
exports.TenantConfig = TenantConfig;
//# sourceMappingURL=tenant-settings.model.js.map